<template>
  <div class="lodging-calculator-container">
    <div>
      <p class="paragraph">Indiquez les proportions pour chaque type d'hébergement ainsi que le nombre de chambres que
        vous avez occupées. Par exemple, pour un séjour de deux nuits avec une en camping et une dans une chambre
        d'hôtel, indiquez 50 % camping et 50 % hôtel avec 1 chambre.</p>
        <div class="mt-20px">
          <button class="button-calculateur" @click="$emit('update:modelValue', {'Sans hébergement':100})">Je n'ai pas besoin d'hébergement pour mon séjour</button>
        </div>  
      <div class="row mt-20px">
        <div v-for="(lodging, index) in lodgings" :key="index" class="col-50">
          <LodgingCalculatorInput class="mt-20px" :lodging="lodging" v-model="results[lodging.type]"
            @update:modelValue="$emit('update:modelValue', results);checkError()"></LodgingCalculatorInput>
        </div>
      </div>
      <div class="d-flex d-flex-end vertical-center mobile-wrap mt-20px">
        <div class="col-30 d-flex vertical-center mobile-margin mobile-end">
          <label class="label-total-input">Total</label><div class="position-relative"> <div class="error">{{ error }}</div><input class="total-input w-100" type="number" :value="totalPercent" readonly/><div class="total-input-percent">%</div></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import LodgingCalculatorInput from '@/components/form/LodgingCalculatorInput.vue'
export default {
  data() {
    return {
      results: {

      },
      error:null,
      lodgings: [
        {
          type: 'Hôtel ou motel',
          icon: require('@/assets/images/hebergement_hotel.png'),
          factor: 4.2
        },
        {
          type: 'Chalet',
          icon: require('@/assets/images/hebergement_chalet.png'),
          factor: 2.55,
        },
        {
          type: 'Camping',
          icon: require('@/assets/images/hebergement_camping.png'),
          onlyOne: true,
          factor: 0.03,
        },
        {
          type: 'Appartement',
          icon: require('@/assets/images/hebergement_appartement.png'),
          factor: 0.7677
        },
        {
          type: 'Auberge',
          icon: require('@/assets/images/hebergement_auberge.png'),
          factor: 3.2
        },
        {
          type: 'Maison',
          icon: require('@/assets/images/hebergement_maison.png'),
          factor: 2.55,
        }
      ]
    }
  },
  components: {
    LodgingCalculatorInput
  },
  props: {
    modelValue: Object
  },
  methods:{
    checkError(){
      if(this.totalPercent!==100){
        this.error='Le total de pourcentage doit être 100%'
        this.$emit('onError', true)
      }
      else{
        this.error=null
        this.$emit('onError', false)
      }
    }
  },
  computed:{
    totalPercent(){
      let total = 0
      Object.keys(this.results).forEach(element=>{
        if(this.results[element].temps){
          total+=parseFloat(this.results[element].temps)
        }
      })
      return total
    }
  },
  watch: {
    modelValue(newVal) {
      this.results = newVal;
    }
  }

}
</script>
<style scoped>
.button-calculateur{
  margin-left: 0px;
}
.lodging-calculator-container {
  position: relative;
  background-color: white;
  padding: 40px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  border-bottom-right-radius: 50px;
  box-shadow: 4px 4px 24px 0px rgba(0, 0, 0, 0.15);
}
@media screen and (max-width: 900px) {
  .col-50{
    width:100%;
  }
  .mobile-wrap{
    flex-wrap: wrap;
  }
  .mobile-end{
    justify-content: end;
  }
  .col-30{
    width:100%;
  }
  .mobile-margin {
    margin-top:20px;
  }
}
</style>